import { render } from "./LegacyGroupRoomConditionReport.vue?vue&type=template&id=7f0b32bc"
import script from "./LegacyGroupRoomConditionReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupRoomConditionReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__